import React, { useState } from 'react';
import {
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  Container,
} from '@mui/material';

import {
  Business,
  Phone,
} from '@mui/icons-material';

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import HomeIcon from '@mui/icons-material/Home';
import { SetGreenhouseCreate } from '../../Conections/GreenhouseConection';

const GreenhouseCreate = () => {

  const goTo = useNavigate();
  const { getToken, getCompany } = useAuth();

  const [greenhouse, setGreenhouse] = useState({
    name: '',
    address: '',
    phone: ''
  });

  const [errors, setErrors] = useState({});

  React.useEffect(() => {
    reloaduser();
  }, []);

  async function reloaduser() {
    if (getToken()) {
      const permisionCan = await can(getToken(), getCompany(), "/greenhouse/creategreenhouse");
      if (permisionCan === 0) {
        goTo("/dashboard");
      }
    }
    else {
      goTo(`/login`);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGreenhouse(prevData => ({
      ...prevData,
      [name]: value
    }));
  };
  
  const validateForm = () => {
    const newErrors = {};
    if (!greenhouse.name.trim()) {
      newErrors.nombre = 'El nombre es requerido';
    }
    if (!greenhouse.address.trim()) {
      newErrors.descripcion = 'La descripción es requerida';
    }
    if (!greenhouse.phone.trim()) {
      newErrors.descripcion = 'La descripción es requerida';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      const datos = await SetGreenhouseCreate(
        getToken(),
        getCompany(),
        greenhouse.name.trim(),
        greenhouse.address.trim(),
        greenhouse.phone.trim()
      );
      goTo(`/greenhouse/showgreenhouse/${datos}`);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          Crear Nuevo Invernadero
        </Typography>
        <Card>
          <CardContent>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Nombre del Invernadero"
                name="name"
                value={greenhouse.name}
                onChange={handleChange}
                InputProps={{
                  startAdornment: <Business sx={{ mr: 1, color: 'action.active' }} />,
                }}
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre}
              />
              <TextField
                fullWidth
                label="Dirección"
                name="address"
                value={greenhouse.address}
                onChange={handleChange}
                required
                InputProps={{
                  startAdornment: <HomeIcon sx={{ mr: 1, color: 'action.active' }} />,
                }}
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre}
              />
              <TextField
                fullWidth
                label="Teléfono"
                name="phone"
                value={greenhouse.phone}
                onChange={handleChange}
                required
                InputProps={{
                  startAdornment: <Phone sx={{ mr: 1, color: 'action.active' }} />,
                }}
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre}
              />

              <Box sx={{ mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  Crear Invernadero
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default GreenhouseCreate;